import { useEffect, useRef, useState } from "react";
import { motion, AnimatePresence } from 'framer-motion';
import { useLanguage } from "../context/LanguageContext";
import heroVideo from "../assets/hero.mp4";
import BookModal from './BookModal';
import Contact from "./Contact";


// === أغطية الكتب حسب اللغة ===
import firstBookCoverAr from "../assets/nojomAr.png";
import firstBookCoverEn from "../assets/nojomEn.png";
// القصة 1
import newStoryCover1Ar from "../assets/DesertAr.png";
import newStoryCover1En from "../assets/DesertEn.png";
// القصة 2
import newStoryCover2Ar from "../assets/SongInTheTreeArpng.png";
import newStoryCover2En from "../assets/SongInTheTreeEnpng.png";
// القصة 3
import newStoryCover3Ar from "../assets/whispersAr.png";
import newStoryCover3En from "../assets/wishpersEn.png";
// القصة 4
import newStoryCover4Ar from "../assets/hArCover2lastexample.png";
import newStoryCover4En from "../assets/hCoverlastexample.png";


import firstIcon from "../assets/gratitude.png";
import secondIcon from "../assets/sunApp.png";
import thirdIcon from "../assets/overviewnew.png";

import "./styles/Hero.css";
import Footer from './Footer';

export default function Hero() {
  const { t, language, toggleLanguage, dir } = useLanguage();
  const titleRef = useRef(null);

  const [selectedBook, setSelectedBook] = useState(null);

 const openBookModal = (book) => {
  const coverSrc = getCoverByLanguage(book.id);
  const title = t(book.titleKey);
  const description = t(book.descKey);
  const longDescription = t(book.longDescKey);
  const pages = t(book.pagesKey);
  const category = t(book.categoryKey);
  const author = t(book.author);
  const downloadLink = getDownloadLink(book.id);
  
  setSelectedBook({
    ...book,
    coverSrc,
    title,
    description,
    longDescription,
    pages,
    category,
    author,
    downloadLink
  });
};

  const closeModal = () => {
    setSelectedBook(null);
  };

  // === روابط التحميل حسب اللغة ===
  const getDownloadLink = (bookId) => {
    const links = {
      ar: {
        1: "/books/NojomAr.pdf",
        2: "/books/حكاية-الصحراء.pdf",
        3: "/books/غناء-في-الشجرة.pdf",
        4: "/books/حوار كالهمس بين عائشة والشمس.pdf",
        5: "/books/HStoryAr1.pdf",
      },
      en: {
        1: "/books/NojomAr.pdf",
        2: "/books/Tale of the Desert.pdf",
        3: "/books/A Song in the Tree.pdf",
        4: "/books/whispers ready.pdf",
        5: "/books/HStoryEn (2).pdf",
      },
    };
    return links[language][bookId];
  };

  // === صورة الغلاف حسب اللغة ===
  const getCoverByLanguage = (bookId) => {
    const covers = {
      ar: {
        1: firstBookCoverAr,
        2: newStoryCover1Ar,
        3: newStoryCover2Ar,
        4: newStoryCover3Ar,
        5: newStoryCover4Ar,
      },
      en: {
        1: firstBookCoverEn,
        2: newStoryCover1En,
        3: newStoryCover2En,
        4: newStoryCover3En,
        5: newStoryCover4En,
      },
    };
    return covers[language][bookId];
  };

  // === بيانات الكتب (العناوين والوصف من ملف الترجمة) ===
  const booksData = [
    {
      id: 1, titleKey: "books.bookTitle", descKey: "books.bookDescription", longDescKey: "books.bookLongDesc",
      pagesKey: "books.bookPages",
      categoryKey: "books.bookCategory", author: "books.autherName", showComingNote: true, showType: false
    },
    {
      id: 2, titleKey: "books.newBook1Title", descKey: "books.newBook1Desc", longDescKey: "books.newBook1LongDesc",
      pagesKey: "books.newBook1Pages",
      categoryKey: "books.newBook1Category", author: "books.autherName1", showComingNote: false, showType: true
    },
    {
      id: 3, titleKey: "books.newBook2Title", descKey: "books.newBook2Desc", longDescKey: "books.newBook2LongDesc",
      pagesKey: "books.newBook2Pages",
      categoryKey: "books.newBook2Category", author: "books.autherName2", showComingNote: false, showType: true
    },
    {
      id: 4, titleKey: "books.newBook3Title", descKey: "books.newBook3Desc", longDescKey: "books.newBook3LongDesc",
      pagesKey: "books.newBook3Pages",
      categoryKey: "books.newBook3Category", author: "books.autherName3", showComingNote: false, showType: true
    },
    {
      id: 5, titleKey: "books.newBook4Title", descKey: "books.newBook4Desc", longDescKey: "books.newBook4LongDesc",
      pagesKey: "books.newBook4Pages",
      categoryKey: "books.newBook4Category", author: "books.autherName4", showComingNote: false, showType: true
    },
  ];



  useEffect(() => {
    const timer = setTimeout(() => {
      if (titleRef.current) {
        titleRef.current.classList.add("animate-in");
      }
    }, 300);

    const scrollToBooks = () => {
      if (window.location.hash === "#books") {
        const hero = document.querySelector(".hero");
        const booksSection = document.querySelector("#books");
        if (hero && booksSection) {
          const heroBottom = hero.offsetTop + hero.offsetHeight;
          window.scrollTo({ top: heroBottom, behavior: "smooth" });
        }
      }
    };

    const video = document.querySelector(".hero-video");
    if (video) {
      if (video.readyState >= 2) scrollToBooks();
      else video.addEventListener("loadedmetadata", scrollToBooks);
    } else {
      window.addEventListener("load", scrollToBooks);
    }

    return () => {
      clearTimeout(timer);
      if (video) video.removeEventListener("loadedmetadata", scrollToBooks);
      window.removeEventListener("load", scrollToBooks);
    };
  }, []);



  return (
    <div style={{ direction: dir }}>
      {/* ========== HERO SECTION ========== */}
      <section className="hero">
        <video className="hero-video" autoPlay loop muted playsInline>
          <source src={heroVideo} type="video/mp4" />
        </video>

        <header className="navbar">
          <motion.nav
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="nav-links"
          >
            <a href="#how">{t("nav.story")}</a>
            <a href="#books">{t("nav.books")}</a>
            <a href="#contact">{t("nav.contact")}</a>
          </motion.nav>
          <button
            className={`lang-btn ${language === "ar" ? "ar" : "en"}`}
            onClick={toggleLanguage}
          >
            {language === "ar" ? "EN" : "عربي"}
          </button>
        </header>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
          className="hero-content"
        >
          <h1 ref={titleRef} className="elegant-title">
            {t("hero.title")}
          </h1>
          <p>{t("hero.subtitle")}</p>
          <motion.div whileHover={{ scale: 1.05 }}>
            <a href="#books" className="hero-btn">
              {t("hero.button")}
            </a>
          </motion.div>
        </motion.div>
      </section>

      {/* ========== HOW / STORY SECTION ========== */}
      <section id="how" className="how-section how-full">
        <div className="how-content">
          <motion.h2
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, margin: "-50px" }}
            transition={{ duration: 0.7, ease: [0.25, 0.1, 0.25, 1] }}
            className="how-title"
          >
            {t("nav.story")}
          </motion.h2>

          <div className="how-grid">
            {[
              { title: t("story.beauty.title"), text: t("story.beauty.text"), icon: firstIcon },
              { title: t("story.message.title"), text: t("story.message.text"), icon: thirdIcon },
              { title: t("story.vision.title"), text: t("story.vision.text"), icon: secondIcon },
            ].map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 25 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, margin: "-50px" }}
                transition={{ delay: i * 0.15, duration: 0.6, ease: [0.34, 1.56, 0.64, 1] }}
                className="how-card"
                whileHover={{ y: -6, transition: { duration: 0.3 } }}
              >
                <motion.div
                  className="how-icon"
                  initial={{ scale: 0.8, opacity: 0, rotate: -5 }}
                  whileInView={{ scale: 1, opacity: 1, rotate: 0 }}
                  viewport={{ once: false }}
                  transition={{ type: "spring", stiffness: 180, damping: 15, delay: i * 0.15 + 0.1 }}
                  whileHover={{ scale: 1.08, y: -4 }}
                >
                  <motion.img
                    src={item.icon}
                    alt={item.title}
                    initial={{ scale: 0.7, opacity: 0 }}
                    whileInView={{ scale: 1, opacity: 1 }}
                    viewport={{ once: false }}
                    transition={{ type: "spring", stiffness: 200, damping: 12, delay: i * 0.15 + 0.15 }}
                  />
                </motion.div>
                <motion.h3
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ delay: i * 0.15 + 0.2, duration: 0.5 }}
                >
                  {item.title}
                </motion.h3>
                <motion.p
                  initial={{ opacity: 0, y: 10 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: false }}
                  transition={{ delay: i * 0.15 + 0.25, duration: 0.5 }}
                >
                  {item.text}
                </motion.p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ========== BOOKS SECTION ========== */}
      <section id="books" className="books-section">
        <div className="books-container">
          <h2 className="books-main-title">{t("books.sectionTitle")}</h2>
          <div className="books-grid">
            {booksData.map((book, index) => (
              <motion.div
                key={book.id}
                className="book-card"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: false, margin: "-50px" }}
                transition={{ delay: index * 0.1, duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}
                whileHover={{ y: -4, transition: { duration: 0.2 } }}
                 onClick={() => openBookModal(book)}
                  style={{ cursor: 'pointer' }}
              >
                <div className="book-cover-wrapper">

                  <img src={getCoverByLanguage(book.id)} alt={t(book.titleKey)} />
                </div>
                <h3>{t(book.titleKey)}</h3>
                <p>{t(book.descKey)}</p>
                <button className="download-btn">
{t("books.download")}
                </button>
                {book.showComingNote && <span className="coming-note">{t("books.type1")}</span>}
                {book.showType && <span className="coming-note">{t("books.type2")}</span>}
              </motion.div>
            ))}
          </div>
        </div>
      </section>
            <Contact />
      <Footer />
      <AnimatePresence mode="wait">
      {selectedBook && (
        <BookModal
            key={language} 
          book={selectedBook}
          coverSrc={getCoverByLanguage(selectedBook.id)}
          downloadLink={getDownloadLink(selectedBook.id)}
          onClose={closeModal}
        />
      )}
      </AnimatePresence>
    </div>
  );
}